<div class="action-container">
  <p class="text-center mb-2">A user with this email address already exists.</p>
  <div>
    <div class="text-center mt-3 pb-0">
      <button class="tv-btn-light btn" aria-label="Open" (click)="modalRef.hide()">
        Close
      </button>
      </div>
  </div>
</div>